import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";

const blank = { year: new Date().getFullYear(), title: "", summary: "", pdf_url: "" };

export default function AdminReports() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/reports").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    await api.post("/reports", { ...form, year: parseInt(form.year) });
    setForm(blank);
    load();
  };
  const del = async (id) => { await api.delete(`/reports/${id}`); load(); };

  return (
    <div data-testid="admin-reports">
      <div className="section-label">Documents</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Yearly Reports</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md grid sm:grid-cols-2 gap-3">
        <input data-testid="report-year" type="number" placeholder="Year" value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="report-title" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <input data-testid="report-pdf" placeholder="PDF URL (https://...)" value={form.pdf_url} onChange={(e) => setForm({ ...form, pdf_url: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <textarea data-testid="report-summary" placeholder="Summary" rows={3} value={form.summary} onChange={(e) => setForm({ ...form, summary: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <button data-testid="report-add" onClick={add} className="bg-slate-950 text-white px-4 py-2 sm:col-span-2 inline-flex items-center gap-2 justify-center"><Plus className="h-4 w-4" /> Add report</button>
      </div>

      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((r) => (
          <div key={r.id} className="bg-white border border-slate-200 p-5 rounded-md">
            <div className="flex justify-between items-start">
              <div className="font-display text-3xl font-bold">{r.year}</div>
              <button data-testid={`report-del-${r.id}`} onClick={() => del(r.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
            </div>
            <div className="font-semibold mt-2">{r.title}</div>
            <p className="text-sm text-slate-600 mt-1">{r.summary}</p>
            <a href={r.pdf_url} target="_blank" rel="noreferrer" className="mt-3 inline-block text-sm underline">Open PDF</a>
          </div>
        ))}
      </div>
    </div>
  );
}
